import { render } from "./UiFormNumber.vue?vue&type=template&id=1fc3ccd9"
import script from "./UiFormNumber.vue?vue&type=script&lang=js"
export * from "./UiFormNumber.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__